import React from "react";
import PropTypes from "prop-types";
import { Stack, Typography, Box, IconButton } from "@mui/material";

import LayerdIcon from "../../../../common/LayerdIcon";
import { DETECTION_ICONS } from "../../../../../icons/detectionLucideIcons";
import {
  PRIMARY_COLOR,
} from "../wafEventDrawerShared";
import {
  spHeaderGradient,
  spHeaderMarkSx,
  spHeaderPathSx,
  spHeaderIdValueSx,
  spIdChipSx,
  spMonoFontFamily,
  spPanelRadius,
  spLh,
} from "./smartParseDrawerUi";

export default function SmartParseDrawerHeader({
  title = "Smart Parse Event",
  eventId,
  method,
  path,
  onCopyEventId,
  embedded = false,
}) {
  const methodLabel = method ? String(method).toUpperCase() : null;
  const pathLabel = path || null;

  const content = (
    <Stack direction="row" spacing={0} sx={{ gap: "13px", minWidth: 0, flex: 1, position: "relative", zIndex: 1 }}>
      <Box sx={spHeaderMarkSx}>
        <LayerdIcon icon={DETECTION_ICONS.wafDetection} size={22} color="primary" />
      </Box>

      <Stack spacing={0} sx={{ flex: 1, minWidth: 0, pt: "1px" }}>
        <Typography
          component="h1"
          sx={{
            m: 0,
            fontSize: 20,
            fontWeight: 600,
            letterSpacing: "-0.015em",
            lineHeight: spLh.title,
            color: PRIMARY_COLOR,
          }}
        >
          {title}
        </Typography>

        {(methodLabel || pathLabel) && (
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            flexWrap="nowrap"
            sx={{ mt: "7px", fontFamily: spMonoFontFamily, fontSize: 12.5, minWidth: 0 }}
          >
            {methodLabel && (
              <Typography
                component="span"
                sx={{
                  px: "8px",
                  py: "2px",
                  borderRadius: "6px",
                  backgroundColor: "rgba(99,113,247,0.12)",
                  color: "#4E5AD6",
                  fontWeight: 600,
                  fontSize: 12.5,
                  letterSpacing: "0.02em",
                  lineHeight: spLh.snug,
                  flexShrink: 0,
                }}
              >
                {methodLabel}
              </Typography>
            )}
            {pathLabel && (
              <Typography component="span" title={pathLabel} sx={spHeaderPathSx}>
                {pathLabel}
              </Typography>
            )}
          </Stack>
        )}

        {eventId && (
          <Box sx={{ ...spIdChipSx, mt: "11px" }}>
            <Typography title={String(eventId)} sx={spHeaderIdValueSx}>
              {eventId}
            </Typography>
            {onCopyEventId && (
              <IconButton
                size="small"
                onClick={() => onCopyEventId(eventId)}
                aria-label="Copy event ID"
                sx={{
                  width: 22,
                  height: 22,
                  borderRadius: "6px",
                  color: PRIMARY_COLOR,
                  flexShrink: 0,
                  "&:hover": { backgroundColor: "#EEF0FE" },
                }}
              >
                <LayerdIcon icon={DETECTION_ICONS.copy} size={13} color="primary" />
              </IconButton>
            )}
          </Box>
        )}
      </Stack>
    </Stack>
  );

  if (embedded) return content;

  return (
    <Box
      sx={{
        background: spHeaderGradient,
        borderRadius: spPanelRadius,
        mb: 0,
      }}
    >
      {content}
    </Box>
  );
}

SmartParseDrawerHeader.propTypes = {
  title: PropTypes.string,
  eventId: PropTypes.string,
  method: PropTypes.string,
  path: PropTypes.string,
  onCopyEventId: PropTypes.func,
  embedded: PropTypes.bool,
};
